import { lazyWithRetries } from '@globals/lazyWithRetries'
import AppPaths from '@globals/paths'
import StandardPageLayout from '@layouts/standardPageLayout'
import RouteLoading from '@shared/routing/RouteLoading'
import { T } from '@transifex/react'
import { Suspense } from 'react'
import { RouteObject } from 'react-router'

const NotificationsRoute = lazyWithRetries(() => import('./index'))

const routes: RouteObject[] = [
  {
    path: AppPaths.tenant.admin.notifications(),
    element: (
      <StandardPageLayout
        maxWidth={900}
        title={<T _str="Notifications" />}
        elementId="notificationsRoute">
        <Suspense fallback={<RouteLoading />}>
          <NotificationsRoute />
        </Suspense>
      </StandardPageLayout>
    ),
  },
]

export default routes
